"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { IExecutionLog } from "@/interfaces/execution-log.interfaces";
import executionLogService from "@/services/execution-log.service";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

export type UseGetExecutionLogsReturn = RequestsBaseReturn<PaginatedResponse<IExecutionLog> | null>;

export interface UseGetExecutionLogsProps extends RequestPagination, GetRequestProps {
  filters: IFilter<IExecutionLog>[];
  _id: number;
}

type GetAllSwrParams = [string, number, number, IFilter<IExecutionLog>[]];

const useGetExecutionLogs = ({
  pageNumber,
  pageSize,
  filters,
  isPaused = false,
}: UseGetExecutionLogsProps): UseGetExecutionLogsReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "status");

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IExecutionLog>, Error, GetAllSwrParams>(
    [SWR_KEYS.getExecutionLogs, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      executionLogService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
      isPaused: () => isPaused,
      shouldRetryOnError: false,
      errorRetryCount: 0,
    }
  );

  return { data, isLoading, error };
};

export default useGetExecutionLogs;
